const moduleRoot = `/messages`;

export const PATHS = {
    MESSAGES: {
        path: `${moduleRoot}`,
    },
};
